import "./BlogInfo.scss";
import { FiClock } from "react-icons/fi";
import { motion } from "framer-motion";
import { FaRegCircleUser } from "react-icons/fa6";
import { baseUrl } from "../../../utils/apiData";

const BlogInfo = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  return (
    <section className="blog_detail p_t p_B">
      <div className="content_wrap p_b">
        <div className="img_wrap">
          <img src={`${baseUrl}/${data?.image}`} alt="Blog" />
        </div>

        <div className="info_content">
          <div className="info_line">
            <div className="info">
              <FaRegCircleUser /> <p>{data?.author}</p>
            </div>
            <div className="info">
              <FiClock /> <p>{formatDate(data?.createdAt)}</p>
            </div>
          </div>

          <motion.div
            initial={{ translateY: 24, opacity: 0 }}
            whileInView={{ translateY: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="des"
            dangerouslySetInnerHTML={{
              __html: data?.content,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default BlogInfo;
